var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00927 11.9983H0.868079C0.638109 11.9983 0.417558 11.907 0.254945 11.7444C0.0923318 11.5817 0.000976562 11.3612 0.000976562 11.1312V2.98234C0.000976562 2.75237 0.0923318 2.53182 0.254945 2.3692C0.417558 2.20659 0.638109 2.11523 0.868079 2.11523H7.01045C7.24042 2.11523 7.46097 2.20659 7.62358 2.3692C7.78619 2.53182 7.87755 2.75237 7.87755 2.98234V11.1312C7.87755 11.2452 7.85508 11.358 7.81143 11.4633C7.76778 11.5686 7.70381 11.6642 7.62317 11.7448C7.54252 11.8253 7.4468 11.8892 7.34146 11.9327C7.23612 11.9762 7.12324 11.9985 7.00927 11.9983ZM1.17156 10.8266H6.70462V3.28699H1.17274L1.17156 10.8266Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42217 10.499C9.26678 10.499 9.11776 10.4372 9.00789 10.3274C8.89801 10.2175 8.83629 10.0685 8.83629 9.91309V1.17176H3.00092C2.84553 1.17176 2.69651 1.11003 2.58664 1.00016C2.47677 0.890286 2.41504 0.741265 2.41504 0.58588C2.41504 0.430495 2.47677 0.281474 2.58664 0.1716C2.69651 0.0617265 2.84553 0 3.00092 0L9.14094 0C9.37091 0 9.59146 0.0913552 9.75408 0.253969C9.91669 0.416582 10.008 0.637133 10.008 0.867103V9.91309C10.008 10.0685 9.94632 10.2175 9.83645 10.3274C9.72657 10.4372 9.57755 10.499 9.42217 10.499Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.3d3041b8.svg";
export { ForwardRef as ReactComponent };